"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactCalendar = require("@vidazoo/react-date-range");
var moment = require("moment");
var surface_1 = require("../surface");
var icon_1 = require("../icon");
var Calendar = /** @class */ (function (_super) {
    tslib_1.__extends(Calendar, _super);
    function Calendar(props, context) {
        return _super.call(this, props, context) || this;
    }
    Calendar.prototype.render = function () {
        var _a = this.props, theme = _a.theme, calendarClassNames = _a.calendarClassNames, surfaceLevel = _a.surfaceLevel, date = _a.date, minDate = _a.minDate, maxDate = _a.maxDate, onChange = _a.onChange, enablePassiveDay = _a.enablePassiveDay, others = tslib_1.__rest(_a, ["theme", "calendarClassNames", "surfaceLevel", "date", "minDate", "maxDate", "onChange", "enablePassiveDay"]);
        var specialDays = [];
        if (date && date.isUTC()) {
            specialDays.push({ date: moment().utc().startOf("day") });
        }
        return (React.createElement(surface_1.default, { level: surfaceLevel, className: theme.surface },
            React.createElement("div", { className: theme["prev-month-icon"] },
                React.createElement(icon_1.default, { iconName: "icon-arrow-left-small", size: 1.2 })),
            React.createElement(ReactCalendar.Calendar, tslib_1.__assign({}, others, { specialDays: specialDays, onlyClasses: true, classNames: calendarClassNames, date: date, minDate: minDate, maxDate: maxDate, onChange: onChange, enablePassiveDay: enablePassiveDay })),
            React.createElement("div", { className: theme["next-month-icon"] },
                React.createElement(icon_1.default, { iconName: "icon-arrow-right-small", size: 1.2 }))));
    };
    Calendar.defaultProps = {
        surfaceLevel: 2,
        date: moment(),
        minDate: moment().subtract(1, "year"),
        maxDate: moment().add(1, "year"),
        enablePassiveDay: true,
    };
    return Calendar;
}(React.Component));
exports.default = Calendar;
